module.exports = __webpack_public_path__ + "img/7.4220f852.jpg";